import React from 'react'

function ChevronRightIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <g clipPath="url(#clip0_2776_3827)">
        <path d="M21.6998 16.2998L11.6998 26.2998L10.2998 24.8998L18.8998 16.2998L10.2998 7.6998L11.6998 6.2998L21.6998 16.2998Z" fill="#393939"/>
      </g>
      <defs>
        <clipPath id="clip0_2776_3827">
          <rect width="32" height="32" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChevronRightIcon
